// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  api_uri: "http://localhost:65278", //'http://localhost:3003',
  recaptchaCode: "6LeBp58UAAAAAL2fzJSgwRvvvl1ZNM25hrfj9zRS",
  event: {
    title: "",
    logo: "esaic2023.png",
    description: "This is a description",
    id: 1092,
  },
  esaic_uri: "http://localhost/MyESA/Profile",
  allowDownloadCertificates: true,
  externalSurveyPopup: {
    isShow: true,
    survelUrl: "https://www.surveymonkey.com/r/KJVR3DK",
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
